@if (status || loading) {
  <div
    class="status-split-dropdown"
    data-testid="entity-status-badge"
    [class.is-open]="open"
    (click)="toggleFromWrapper()"
    (keydown)="onKey($event)"
    [attr.tabindex]="disabled ? -1 : 0"
    role="button"
    aria-haspopup="listbox"
    [attr.aria-expanded]="open"
    [class.disabled]="disabled"
    [class.loading]="loading"
  >
    @if (loading) {
      <div class="sub-status-text">Loading...</div>
    } @else {
      <div
        class="primary-tag"
        data-testid="status-primary-tag"
        [attr.data-status]="normalizedStatus"
      >
        {{ primaryPart }}
      </div>
      @if (hasSubStatus) {
        <div class="sub-status-text" data-testid="status-sub-tag">
          {{ dropdownSelected }}
        </div>
      }
      @if (!disabled) {
        <span class="material-symbols-outlined chevron" aria-hidden="true">
          {{ open ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </span>
      }
    }
    @if (open && !loading && !disabled) {
      <div class="split-menu" role="listbox">
        @for (item of dropdownItems; track item) {
          <div
            class="split-menu__option"
            role="option"
            [attr.aria-selected]="item === dropdownSelected"
            [class.active]="item === dropdownSelected"
            (click)="onSelect(item); $event.stopPropagation()"
          >
            {{ item }}
          </div>
        }
      </div>
    }
  </div>
}
